import React from 'react';

import { Props } from './Status.types';
import { Styled } from './Status.styles';

export enum Statuses {
  new,
  wip,
  closed,
  notAchieved,
}

export const statusVariants = [
  'Создано',
  'В работе',
  'Завершено',
  'Не выполнено',
];

export const Status: React.FC<Props> = (props) => {
  return (
    <Styled.Status {...props}>{statusVariants[props.status]}</Styled.Status>
  );
};
